export default Object.freeze({
  SUBJECT_PROPERTY_LOAD: 'subject-property-load',
  SUBJECT_PROPERTY_NEW_SEARCH: 'subject-property-new-search',
  SEARCH_EXPORT_COMPARABLES: 'search-export-comparables',
  SEARCH_CLEAR_FILTERS: 'search-clear-filters',
  SEARCH_APPLY_FILTERS: 'search-apply-filters',
  SEARCH_MODIFY_CIRCLE: 'search-modify-circle',
  SEARCH_MODIFY_POLYGON: 'search-modify-polygon',
  SEARCH_CLICK_SATELLITE_VIEW: 'search-click-satellite-view',
  SEARCH_CLICK_MAP_VIEW: 'search-click-map-view',
  SEARCH_PROFILE_VIEW_UPLOAD_DOCUMENT: 'search-profile-view-upload-document',
  SEARCH_PROFILE_VIEW_ON_GOOGLE_MAPS: 'search-profile-view-on-google-maps',
  SEARCH_PROFILE_COPY_COMPARABLE: 'search-profile-copy-comparable',
  SEARCH_PROFILE_CHANGE_LOG: 'search-profile-change-log',
  SEARCH_PROFILE_DELETE_COMP: 'search-profile-delete-comp',
  SEARCH_PROFILE_SAVE: 'search-profile-save',
  PERSONA_SAVE: 'persona-save',
  PAGE_LOAD: 'page-load',
  CHANGE_INSTANCE: 'change-instance',
});
